import React from 'react';
import styled from 'styled-components';
import { Heading2, spacing, TextParagraph } from '../../../theme';
import colors from '../../../theme/variables/colors';

const HeaderSection = styled.div`
    border-bottom: 2px solid ${colors.palette.black};
    min-width: 253.33px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
`;
const InfoElementHeader = styled(Heading2)`
    display: inline;
    margin-bottom: ${spacing.spacing2};
    align-items: center;
    flex: 1 1 auto;
    min-width: min-content;
`;
const SplitRight = styled.div`
    display: flex;
    width: auto;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
`;
const Text = styled(TextParagraph)`
    margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing3} ${spacing.spacing0};
`;

interface CardHeaderProps {
    id?: string;
    title: string;
    link?: React.ReactNode;
}

function CardHeader({ id, title, link }: CardHeaderProps) {
    return (
        <>
            <HeaderSection>
                <InfoElementHeader id={id ? id : 'infoelementheader'} styledAs="h3" tabIndex={-1}>
                    {title}
                </InfoElementHeader>
                    
                {link && <SplitRight id="infoelementsplit">
                    <Text/>{' '}
                    {link}
                </SplitRight>}
            </HeaderSection>
        </>
    );
}

export default CardHeader;
